import { ALERT_BOTTOM_MARGIN, ALERT_TOP_MARGIN } from "@components/alert/Alert.styles";
import { AlertPosition } from "@components/alert/Alert.types";
import { StyledButton, StyledButtonGroup } from "@components/button";
import styled, { css } from "styled-components";

import Alert from "../../components/alert/Alert";
import SmartFilterBar from "../../components/smart/smartFilterBar/SmartFilterBar";
import Tabs from "../../components/tabs";
import { TableSizes } from "../../enums";
import { T_TITLE_2 } from "../../global.style";


export const TableWrapper = styled.div<{
    isInTab?: boolean;
    hasMinHeight?: boolean;
}>`
    min-height: ${props => props.hasMinHeight === false ? 0 : "100px"};
    max-height: 100%;
    margin-top: 5px;
    flex: 1;
    position: relative;
        // width: calc(100% + ${`${TableSizes.ShadowPadding}px`});
        // left: ${`${-TableSizes.ShadowPadding}px`};
`;

export const FormTableWrapper = styled(TableWrapper) <{
    isInTab?: boolean;
}>`
    ${props => props.isInTab
        ? css`
            margin-top: 20px;
        `
        : css`
            margin-bottom: 10px;
            min-height: unset;
        `
    }
`;

export const TopWrapper = styled.div<{
    _loaded: boolean
}>`
    opacity: ${props => props._loaded ? "1" : "0"}
`;

export const SmartFilterBarStyled = styled(SmartFilterBar)`
    margin-bottom: 36px;
`;

export const TableAlert = styled(Alert)<{
    position?: AlertPosition;
}>`
    margin-bottom: ${ALERT_BOTTOM_MARGIN}px;

    ${props => props.position !== AlertPosition.CenteredBottom && css`
        &:not(:first-child) {
            margin-top: ${ALERT_TOP_MARGIN}px;
        }
    }`}
`;

export const SecondaryTableViewTitle = styled.div`
    ${T_TITLE_2};
    margin-bottom: 20px;
`;
export const StyledTableTabs = styled(Tabs) <{$isHidden?: boolean}>`
    margin-top: 24px;
    opacity: ${props => props.$isHidden ? "0" : "1"};
`;

export const TableButtonFooter = styled.div<{
    hasTopMargin?: boolean;
}>`
    display: flex;
    margin-top: ${props => props.hasTopMargin === false ? 0 : "22px"};
    justify-content: flex-end;

    ${StyledButton} {
        margin-bottom: 38px;
    }

    ${StyledButtonGroup} {
        justify-content: flex-end;
    }
`;